// Source/Product-Set/Component.ts
class ProductSet extends HTMLElement {
  controller;
  connectedCallback() {
    this.controller = new AbortController;
    this.listen();
  }
  disconnectedCallback() {
    this.controller.abort();
  }
  listen() {
    const { signal } = this.controller;
    this.$select.addEventListener("change", () => {
      window.location.href = this.url;
    }, { signal, capture: true });
  }
  get $select() {
    return this.querySelector(`select`);
  }
  get url() {
    return this.$select.value;
  }
}

// Source/Product-Set/mod.ts
customElements.define("product-set", ProductSet);
